module.exports = __webpack_public_path__ + "static/media/guide-version-history.171675eb.png";